import { useMemo, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useOnboardingSummary, ONBOARDING_SUMMARY_QUERY_KEY } from "../modules/onboarding/amazon/useOnboardingSummary";
import { useAppSelector } from "../redux/hooks";

export function useIsSPAPIConnected() {
  const queryClient = useQueryClient();
  const organizationId = useAppSelector((state) => state.user.organization_id);
  const channel = useAppSelector((state) => state.channel.currentChannel);

  const { data: onboardingData } = useOnboardingSummary({
    enabled: !!organizationId && channel === "amazon",
  });

  const isSPAPIConnected = useMemo(() => {
    return (
      onboardingData &&
      (onboardingData.amazon_mws_seller_id ||
        onboardingData.eu_amazon_mws_seller_id ||
        onboardingData.fe_amazon_mws_seller_id)
    );
  }, [onboardingData]);

  useEffect(() => {
    if (isSPAPIConnected) return;
    const handle = setInterval(() => {
      void queryClient.invalidateQueries({
        queryKey: ONBOARDING_SUMMARY_QUERY_KEY,
      });
    }, 1000);
    return () => clearInterval(handle);
  }, [isSPAPIConnected, queryClient]);

  return isSPAPIConnected;
}
